import { Box, FlexLayout, H4 } from '@deity/falcon-ui';
import { EndpointContext } from 'contexts/EndpointContext';
import { useContext } from 'react';
import ReactJson from 'react-json-view';

export const EndpointConfigJSON = () => {
  const ctx = useContext(EndpointContext);

  return (
    <FlexLayout p="xl">
      <H4 mb="lg" fontWeight="semiBold" fontSize="xl">
        Endpoint configuration
      </H4>
      <Box width="full">
        <ReactJson src={ctx?.state || {}} name={null} theme="solarized" />
      </Box>
    </FlexLayout>
  );
};
